export type ApplicationFormAction =
  | ApplicationGetContinueTokenAction
  | ApplicationGetContinueTokenSucessAction
  | ApplicationClearStateAction;

export const ApplicationGetContinueTokenActionType =
  "application-continue-token/get" as const;
export type ApplicationGetContinueTokenAction = ReturnType<
  typeof applicationGetContinueTokenAction
>;
export function applicationGetContinueTokenAction(token: string) {
  return {
    type: ApplicationGetContinueTokenActionType,
    token,
  };
}

export const ApplicationGetContinueTokenSuccessActionType =
  "application-continue-token/get-success" as const;
export type ApplicationGetContinueTokenSucessAction = ReturnType<
  typeof applicationGetContinueTokenSuccessAction
>;
export function applicationGetContinueTokenSuccessAction(
  continueToken: string
) {
  return {
    type: ApplicationGetContinueTokenSuccessActionType,
    continueToken,
  };
}

export const ApplicationClearStateActionType =
  "application/clear-state" as const;
export type ApplicationClearStateAction = ReturnType<
  typeof applicationClearAction
>;
export function applicationClearAction(
  editing?: boolean,
  term?: string,
  redirect?: boolean
) {
  return {
    type: ApplicationClearStateActionType,
    editing,
    term,
    redirect,
  };
}
